import React, { memo, useEffect } from 'react';
import { pageActions } from '../types';
import { usePages } from '../../';
export var FBConnector = memo(function (_a) {
    var pathname = _a.pathname, dispatch = _a.dispatch;
    var pages = usePages().pages;
    useEffect(function () {
        var id = null;
        var parent = null;
        if (pathname === '/') {
            id = 'landing';
        }
        else {
            var path = pathname.split('/').filter(function (part) { return part !== ''; });
            id = path[path.length - 1];
            parent = path.length > 1 ? path.filter(function (part) { return part !== id; }) : null;
        }
        var page = pages.list[id] || {
            id: id,
            parent: parent,
            photoURL: '',
            title: '',
            blocks: { top: [], right: [], bottom: [], left: [], main: [] },
            version: 2,
            deleted: false
        };
        dispatch({ type: pageActions.SUCCESS, data: page });
    }, [dispatch, pathname, pages.list]);
    return (React.createElement(React.Fragment, null));
});
